import { createFileRoute, notFound } from "@tanstack/react-router";

import { LeadMagnetView } from "@/components/pages/LeadMagnetView";
import { landingMagnets } from "@/content/landing-magnets";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/booster-reminders")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/booster-reminders",
          ...landingMagnets[params.locale].boosterReminders.meta,
          smartBanner: true,
        })
      : {},
  component: BoosterRemindersRoute,
});

function BoosterRemindersRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <LeadMagnetView locale={locale} page="boosterReminders" />;
}
